import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  ModalFooter,
  Text,
  HStack,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  addCityListAsync,
  deleteCityListAsync,
  fetchCityListAsync,
  selectCity,
  updateCityListAsync,
} from "../../CityList/CityListSlice";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function CityList() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const dispatch = useDispatch();
  const city = useSelector(selectCity);

  useEffect(() => {
    dispatch(fetchCityListAsync());
  }, [dispatch]);

  const [newCity, setnewCity] = useState("");
  const [newStatus, setnewStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editCity, seteditCity] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editStatus, seteditStatus] = useState("");
  const [editableCity, seteditableCity] = useState(null);
  const [deletingCity, setdeletingCity] = useState(null);

  const handleDelete = async (uuid) => {
    await dispatch(deleteCityListAsync(uuid));
    dispatch(fetchCityListAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setdeletingCity(job);
    dispatch(fetchCityListAsync());

    onOpen2();
  };

  const handleSave = async () => {
    const cityData = {
      title: newCity,
      status: newStatus, // Get status from input
    };

    try {
      await dispatch(addCityListAsync(cityData));

      dispatch(fetchCityListAsync());
      setnewCity(""); // Clear input field after saving
      setnewStatus(""); // Clear status field
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (cityData) => {
    seteditableCity(cityData);
    seteditCity(cityData.title);
    seteditStatus(cityData.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editCity.trim()) {
      try {
        await dispatch(
          updateCityListAsync({
            uuid: editableCity.uuid,
            cityData: {
              title: editCity,
              status: editStatus, // Include status
            },
          })
        );

        dispatch(fetchCityListAsync());
        seteditableCity(null);
        seteditCity("");
        seteditStatus(""); // Reset status
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className=" ">
        <div className="w-full my-5 bg-white rounded-xl">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              City List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add City
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter City"
                              value={newCity}
                              onChange={(e) => setnewCity(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter City Status"
                              value={newStatus}
                              onChange={(e) => setnewStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleSave}>
                      Save
                    </Button>
                    <Button onClick={onClose1}>Cancel</Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit City
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter City"
                              value={editCity}
                              onChange={(e) => seteditCity(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>City Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter status"
                              value={editStatus}
                              onChange={(e) => seteditStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleUpdate}>
                      Update
                    </Button>
                    <Button onClick={() => setIsEditModalOpen(false)}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingCity?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingCity.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">id</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action </Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(city) && city.length > 0 ? (
                  [...city]
                    .sort((a, b) => a.uuid - b.uuid)
                    .map((job, index) => (
                      <Tr key={job.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job.title}</Td>
                        <Td textColor={"green"}>{job.status}</Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit City" placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit industry"
                              />
                            </Tooltip>
                            <Tooltip label="Delete City" placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete industry"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default CityList;
